import { call, put, takeLatest } from 'redux-saga/effects'
import axiosApi from '../../../views/client/axiosClient'
import { handleRequest} from '../../../lib/common'
import * as salaryConstant from './constants'

import * as orderAaction from './actions'

function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}

function* salaryReportNvkdRequestFlow({payload}) {
  try {
    const request = axiosApi().post(
      salaryConstant.SALARY_REPORT_NVKD_API,
      payload
    )
    // grab the client from our action
    const { data } = yield call(handleRequest, request)

    // dispatch the action with our widgets!
    yield put(orderAaction.salaryReportNvkdSuccess(data))

  } catch (error) {
    yield put(orderAaction.salaryReportNvkdError(error))
  }
}

function* salaryReportListRequestFlow({payload}) {
  try {
    const request = axiosApi().post(
      salaryConstant.SALARY_REPORT_LIST_API,
      payload
    )
    // grab the client from our action
    const { data } = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    yield put(orderAaction.salaryReportListSuccess(data))

  } catch (error) {
    yield put(orderAaction.salaryReportListError(error))
  }
}

function* reportExportXlsRequestFlow( { payload, callback } ) {
  try {
    const url = salaryConstant.SALARY_REPORT_EXPORT_XLS_API + "?st=" + payload.tu_ngay + "&ed=" + payload.den_ngay + "&kd=" + payload.listNvkd + "&tt=" + payload.trangThai+ "&isTDV=" + payload.isTDV;
    const request = axiosApi().get(
      url,
      {
        responseType: 'blob'
      }
    );
    // grab the client from our action
    const { data } = yield call(handleFileRequest, request)
    // dispatch the action with our widgets!
    yield put(orderAaction.reportExportXlsSuccess(data))
    if (typeof callback == 'function') {
      yield call(callback, data);
    }
  } catch (error) {
    yield put(orderAaction.reportExportXlsError(error))
  }
}


function* salaryReportWatcher() {
  yield [
    takeLatest(salaryConstant.SALARY_REPORT_NVKD_REQUESTING, salaryReportNvkdRequestFlow),
    takeLatest(salaryConstant.SALARY_REPORT_LIST_REQUESTING, salaryReportListRequestFlow),
    takeLatest(salaryConstant.REPORT_EXPORT_XLS_REQUESTING, reportExportXlsRequestFlow),
  ]
}

export default salaryReportWatcher



// WEBPACK FOOTER //
// ./src/views/Reports/SalaryReport/sagas.js